import React from 'react'
import { FiCornerRightDown, FiCornerDownRight } from 'react-icons/fi'
import cn from 'classnames'
import type { ListSettings } from 'types/shapes'

import 'components/graph/controls/controls.less'

type ToggleShapeDirectionControlProps = {
  direction: ListSettings['direction']
  onClick: () => void
  disabled?: boolean
}

const ToggleShapeDirectionControl = ({ direction, onClick, disabled }: ToggleShapeDirectionControlProps) => {
  const label = direction === 'horizontal' ? 'Arrange vertically' : 'Arrange horizontally'

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    if (disabled) return
    onClick()
  }

  return (
    <div className={cn('control', 'toggle-shape-direction')} data-graph-type="control" title={label}>
      <a className={cn('icon', { disabled })} onClick={handleClick}>
        {direction === 'horizontal' ? <FiCornerRightDown aria-hidden /> : <FiCornerDownRight aria-hidden />}
        <span className="sr-only">{label}</span>
      </a>
    </div>
  )
}

export default ToggleShapeDirectionControl
